// extracted by mini-css-extract-plugin
export default {"cls1":"PaperImages-cls1_ee4","cls2":"PaperImages-cls2__1u PaperImages-cls1_ee4"};